import { formatDate } from "../../../handlers/dateFormatter";

function PostTemplate({ title, content, date, author, authorAvatar, image }) {
	return (
		<div className="col-xl-6 col-lg-8 mx-auto">
			<h2>{title}</h2>
			<div className="my-2">
				<img
					style={{
						borderRadius: "50%",
						objectFit: "cover",
						height: "2.5rem",
						width: "2.5rem",
					}}
					src="https://progitek.no/wp-content/uploads/2022/11/ole-petter.png"
				/>
				<small>
					{" "}
					Av <strong>{author}</strong> den {formatDate(date)}
				</small>
			</div>
			{image && (
				<div className="my-4">
					<img src={image} alt="" className="img-fluid" />
				</div>
			)}
			<hr />

			<div dangerouslySetInnerHTML={{ __html: content }} />
		</div>
	);
}
export default PostTemplate;
